<template lang="pug">
	.audit-copy-delete-project
		.row-options
			a(@click="showProject(params.data)") Copy
			span.limit &nbsp;|&nbsp;
			router-link.audit-option(:to="{name: 'project.audit', params: { id: params.data.projId, printable: false } }") Audit
			span.limit &nbsp;|&nbsp;
			a(@click="openDelete(params.data.projId)") Delete

		md-dialog-confirm(
		:md-active.sync='confirmDilog.show',
		:md-title="confirmDilog.title",
		:md-content='confirmDilog.content',
		:md-confirm-text='$t("label.ok")',
		:md-cancel-text='$t("label.no")',
		@md-cancel='',
		@md-confirm='confirmDelete')
</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/common/event-bus.js'

export default Vue.extend({
	name: 'ag-grid-delete-project',
	data () {
		return {
			project: {},
			userId: '',
			confirmDilog: {
				show: false,
				title: '',
				content: '',
				projId: null,
				lockStateTemp: null
			}
		}
	},
	methods: {
		openDelete (projId) {
			this.confirmDilog.title = 'Confirm delete?'
			this.confirmDilog.content = 'Are you sure to delete the project'
			this.confirmDilog.show = true
			this.confirmDilog.projId = projId
		},
		confirmDelete () {
			Vue.e24.projectService.delete(this.confirmDilog.projId).then((delRes) => {
				// console.log('Project deleted', delRes)
				// this.loadData()
				EventBus.$emit('is-load-data')
			})
		},
		showProject (wichProject) {
			let project = wichProject
			Vue.e24.projectService
				.clone(project.userId, project.projId)
				.then(addedPrj => {
					const gotoProject = {
						name: 'project.takeoff',
						params: {
							id: addedPrj.projId
						}
					}
					this.$router.push(gotoProject)
				})
				.catch(error => {
					if (error) {
						console.error('Clone method error: ' + JSON.stringify(error.errors))
					}
				})
		}
	}
})
</script>



// WEBPACK FOOTER //
// src/app/project/ag-grid/audit-copy-delete-project.vue